import React from 'react';
import { useAuth } from '../utils/AuthContext';
import { useNavigate } from 'react-router-dom';
import ChatInterface from '../components/Chat/ChatInterface';
import ExportPanel from '../components/ExportPanel';

const Dashboard = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [conversationKey, setConversationKey] = React.useState(0);
  const [usageRefresh, setUsageRefresh] = React.useState(0);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleNewConversation = () => {
    setConversationKey(prev => prev + 1);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex justify-between items-center">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">
                Site Intelligence Platform
              </h1>
              <p className="text-sm text-gray-600 mt-1">
                Welcome, {user?.full_name} ({user?.role?.replace('_', ' ')})
              </p>
            </div>
            <div className="flex space-x-4">
              {user?.role === 'admin' && (
                <button
                  onClick={() => navigate('/admin')}
                  className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  Admin Dashboard
                </button>
              )}
              <button
                onClick={() => navigate('/guide')}
                className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500"
              >
                Guide
              </button>
              <button
                onClick={handleLogout}
                className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Cost display removed from main chat page - costs shown only in Admin Dashboard */}

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          {/* Sidebar */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-lg shadow p-4">
              <h2 className="text-lg font-semibold mb-4">Quick Actions</h2>
              <div className="space-y-2">
                <button 
                  onClick={handleNewConversation}
                  className="w-full text-left px-3 py-2 rounded hover:bg-gray-100"
                >
                  New Conversation
                </button>
                <button 
                  onClick={() => navigate('/guide')}
                  className="w-full text-left px-3 py-2 rounded hover:bg-gray-100 text-green-600"
                >
                  📖 Platform Guide
                </button>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow p-4 mt-4">
              <h2 className="text-lg font-semibold mb-4">Profile</h2>
              <div className="space-y-2 text-sm">
                <div>
                  <span className="text-gray-600">Role:</span>
                  <span className="ml-2 font-medium">
                    {user?.role?.replace('_', ' ')}
                  </span>
                </div>
                {user?.department && (
                  <div>
                    <span className="text-gray-600">Department:</span>
                    <span className="ml-2 font-medium">{user.department}</span>
                  </div>
                )}
                {user?.specialty && (
                  <div>
                    <span className="text-gray-600">Specialty:</span>
                    <span className="ml-2 font-medium">{user.specialty}</span>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Chat Area */}
          <div className="lg:col-span-3 h-[calc(100vh-12rem)]">
            <ChatInterface 
              key={conversationKey} 
              onMessageSent={() => setUsageRefresh(prev => prev + 1)}
            />
          </div>
        </div>
      </main>
    </div>
  );
};

export default Dashboard;
